/** @format */

import React, { useState, useEffect, useContext } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { Box, Button, Grid, IconButton } from "@mui/material";
import "./index.scss";
import { checkForUserLimit, exportToExcel, formatDate } from "../../../utils";
import {
  DATE_FORMATS,
  TICKET_STAGES,
  USER_LIMITS,
  USER_ROLES,
} from "../../../utils/constants";
import { FileDownloadOutlined } from "@mui/icons-material";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import SiTextField from "../../../core/si-textfield";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import CustomButtonComponent from "../../../core/custom-button";
import {
  SERVICE_LABEL_MAP,
  viewFormConfig,
} from "../../../components/service-tickets/config";
import EditForm from "../../../components/service-tickets/edit-form";
import AppContext from "../../../utils/context";
import moment from "moment";
const ViewBasicForm = ({ details, onClose, ticketDetails, loadTicketData }) => {
  const [formData, setFormData] = useState({});
  const [comment, setComment] = useState("");
  const [isEditForm, setEditForm] = useState(false);
  const { userDetails = {} } = useContext(AppContext);
  const navigate = useNavigate();
  const {
    oemEngineLocation = {},
    freeServiceDetails = {},
    pastHistory = [],
  } = details;

  const location =
    oemEngineLocation &&
    `${oemEngineLocation.tractorAddress || ""},${
      oemEngineLocation.pinCode || ""
    }`;
  const downloadExcel = () => {
    const data = [
      {
        Ticket: details.ticketId,
        "Name of OEM": details.oemName,
        "Service Eng Name": details.oemServiceEngineerName,
        "Service Eng Contact": details.oemServiceEngineerContact,
        "Engine Location": location,
        "OEM Dealer Name": details.oemDealerName,
        "Engine Serial Number": details.engineSerialNumber,
        "Unit/Machine Current Status": details.unitMachineStatus,
        "Unit Serial Number": details.unitSerialNumber,
        "Date of Sale": formatDate(
          details.dateOfSale,
          DATE_FORMATS["DD-MM-YYYY"]
        ),
        "Customer Complaint Date": formatDate(
          details.customerComplaintDate,
          DATE_FORMATS["DD-MM-YYYY"]
        ),
        "Customer Complaint Nature": details.natureOfCustomerComplaint,
        HMR: details.hmr,
        "Customer Name": details.customerName,
        "Customer Contact": details.customerContact,
        "Investigation Details By OEM": details.investigationDetailsByOem,
        Remarks: details.remarks,
        "Customer Regular Application": details.customerRegularApplication,
        "Complaint Observed Application":
          details.applicationWhileComplaintObserved,
        "Soil Condition": details.soilCondition,
        Attachments: details.attachments,
      },
    ];
    exportToExcel(data, "Ticket Form");
  };
  const addComments = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.OEM_COMMENT}/${details.ticketId}`,
      {
        comment,
      }
    )
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          toast.success("Comment Added");
          setComment("");
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    setFormData({
      oemName: ticketDetails?.oemOrg?.name || details.oemName,
      oemServiceEngineerName: details.oemServiceEngineerName,
      oemServiceEngineerContact: details.oemServiceEngineerContact,
      tractorAddress: oemEngineLocation.tractorAddress,
      state: oemEngineLocation.state,
      city: oemEngineLocation.city,
      pinCode: oemEngineLocation.pinCode,
      oemDealerName: details.oemDealerName,
      engineSerialNumber: details.engineSerialNumber,
      unitSerialNumber: details.unitSerialNumber,
      cutInNumber: ticketDetails.cutInNumber,
      dateOfSale:
        details?.dateOfSale && moment(details.dateOfSale).format("DD-MM-YYYY"),
      cqc: details?.cqc || "",
      customerComplaintDate:
        details?.customerComplaintDate &&
        moment(details.customerComplaintDate).format("DD-MM-YYYY"),
      natureOfCustomerComplaint: {
        label: `${ticketDetails?.customerComplaintCode?.code}-${ticketDetails?.customerComplaintCode?.description}`,
        value: ticketDetails?.customerComplaintCode?.id,
      },
      unitMachineStatus: details.unitMachineStatus,
      hmr: details.hmr,
      customerName: details.customerName,
      customerContact: details.customerContact,
      investigationDetailsByOem: details.investigationDetailsByOem,
      remarks: details.remarks,
      customerRegularApplication: details.customerRegularApplication,
      actionTakenByOem: details.actionTakenByOem,
      applicationWhileComplaintObserved:
        details.applicationWhileComplaintObserved,
      soilCondition: details.soilCondition,
    });
  }, [details]);
  return (
    <div className="page-load">
      <Grid container spacing={3}>
        <Grid item md={12} sx={{ mt: 3 }}>
          {isEditForm ? (
            <EditForm
              ticketForm={formData}
              details={details}
              setEditForm={setEditForm}
              loadTicketData={loadTicketData}
            />
          ) : (
            <div className="form-con" style={{ margin: "0px", width: "100%" }}>
              {(checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) ||
                userDetails?.role === USER_ROLES.OEM) &&
                ticketDetails.status !== "CLOSED" && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <IconButton onClick={() => setEditForm(true)}>
                      <EditIcon />
                    </IconButton>
                  </Box>
                )}

              <PreviewFormGenerator
                formConfig={viewFormConfig}
                formValues={formData}
              />
              <Grid container>
                <Grid item md={6} xs={12}>
                  {Object.keys(freeServiceDetails).length > 0 && (
                    <div>
                      <p className="primary-text">Free Services</p>
                      <div className="free-services">
                        {Object.keys(freeServiceDetails).length > 0 && (
                          <div className="service-row table-head-bg">
                            <div>Service</div>
                            <div>Date</div>
                            <div>Hours</div>
                          </div>
                        )}

                        {Object.keys(freeServiceDetails).map((key) => {
                          return (
                            <div
                              className={
                                key === "firstService" &&
                                freeServiceDetails[key]["runningHours"] > 50
                                  ? "service-row error"
                                  : "service-row"
                              }
                            >
                              <div>{SERVICE_LABEL_MAP[key]}</div>
                              <span>
                                {formatDate(
                                  freeServiceDetails[key]["date"],
                                  DATE_FORMATS["DD-MM-YYYY"]
                                )}
                              </span>
                              <div>
                                {freeServiceDetails[key]["runningHours"]}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </Grid>
                <Grid item md={6}>
                  {pastHistory.length > 0 && (
                    <div>
                      <p className="primary-text">Past History</p>
                      <div className="free-services">
                        {pastHistory.length > 0 && (
                          <div className="service-row table-head-bg">
                            <div>Date Of Failure</div>
                            <div>Complaint Reported</div>
                            <div>Hours</div>
                          </div>
                        )}
                        {pastHistory.map((h) => {
                          return (
                            <div className="service-row">
                              <span>
                                {formatDate(
                                  h.dateOfFailure,
                                  DATE_FORMATS["DD-MM-YYYY"]
                                )}
                              </span>
                              <div>{h.complaintReported}</div>
                              <div>{h.hours}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ViewBasicForm;
